import TabContainer from "../../../../../common/components/tab/containers/tab.containers";
import DSAPAgencyMyApprovals from "./my-approvals";
import DSAPAgencyMyAgencies from "./my-partners";
import DSAPAgencyMyRequests from "./my-requests";
import DSAPAgencyRejectedRequests from "./rejected-requests";


export const MyShipXAgencies = () => {
    const tabItems = [
        {
          id: 1,
          title: 'My Agencies',
          component: <DSAPAgencyMyAgencies/>,
          isVisible: true,
        },
        {
          id: 2,
          title: 'My Requests',
            component:<DSAPAgencyMyRequests/>,
          isVisible: true,
        },
        {
          id: 3,
          title: 'My Approvals',
          component:<DSAPAgencyMyApprovals/>,
          isVisible: true,
        },
         {
          id: 4,
          title: 'My NP Approvals',
          component:<DSAPAgencyMyApprovals/>,
          isVisible: true,
        },
         {
          id: 5,
          title: 'Partner NP Approvals',
          component:<DSAPAgencyMyApprovals/>,
          isVisible: true,
        },
        {
          id: 6,
          title: 'Rejected Requests',
          component:<DSAPAgencyRejectedRequests/>,
          isVisible: true,
      },]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
      <TabContainer tabItems={tabItems} />
       </div>
  )
}
export default MyShipXAgencies;
